import { apiFetch } from '../apiFetch'

export const putQueueItem = async (payload) => {
  const { id, ...updateData } = payload
  return await apiFetch({
    method: 'PUT',
    path: `/queue_items/${id}`,
    payload: updateData
  })
}
